<template>
  <div>
    <div class="benefit-title" v-if="benefitTitle">{{ benefitTitle }}</div>
    <div class="benefit-boxes">
      <BenefitBox
        :requiresLogin="true"
        v-if="memberBenefits.length > 0"
        :benefits="memberBenefits"
        :title="memberBenefitsTitle"
        :is-member="true"
        theme="blue"
        :starts-questions="true"
      />
      <BenefitBox
        @start-lead-popup="handleStartLeadPopup"
        v-if="memberBenefits.length > 0"
        :benefits="generalBenefits"
        :title="generalBenefitsTitle"
        theme="default"
        :is-member="false"
        :starts-questions="true"
      />
    </div>
    <!-- Non member - lead popup -->
    <LeadPopup @close="handleLeadClose" :modalOpen="isLeadPopup" @submit="handleLeadSubmit" />
  </div>
</template>

<script>
import { state } from '@/lib/state'
import BenefitBox from '@/components/BenefitBox.vue'
import LeadPopup from '@/components/leadPopup.vue'
import {
  getPreviousSalaryData,
  getAuthenticatedMemberId,
  getMasterDataForMember,
} from '@/services/user-data-service.js'
import { isDevelopment } from '@/services/environment-service'
import { isAuthenticated } from '../../../../services/service-api-member.js'

export default {
  components: {
    BenefitBox,
    LeadPopup,
  },
  data() {
    return {
      isLeadPopup: false,
      benefitTitle: state.benefitsTitle,
      memberBenefitsTitle: state.memberBenefitsTitle,
      generalBenefitsTitle: state.generalBenefitsTitle,
      memberBenefits: state.memberBenefits,
      generalBenefits: state.generalBenefits,
    }
  },
  async beforeCreate() {
    const isLoggedIn = await isAuthenticated()
    state.user.isMember = isLoggedIn
    
    // Update segmentation based on authentication status
    if (isLoggedIn) {
      // If user is authenticated and there's no URL parameter, dispatch member event
      const urlParams = new URLSearchParams(window.location.search)
      if (!urlParams.has('seg')) {
        window.dispatchEvent(new CustomEvent("segmentation-reset"))
        window.dispatchEvent(new CustomEvent("subscriptiontype-member"))
        
        // Update URL to reflect member status
        const url = new URL(window.location)
        urlParams.set("seg", "member")
        url.search = urlParams.toString()
        history.replaceState(null, "", url.toString())
      }
    }
  },
  methods: {
    handleLeadSubmit() {
      this.emitter.emit('start-questions')
      this.$emit('submit')
      
      // Set the segmentation parameter in URL to match the appropriate user type
      // For non-members, we'll use a default of 'employed' 
      const segType = 'employed'
      const eventType = "subscriptiontype-" + segType
      
      // Dispatch the segmentation events
      window.dispatchEvent(new CustomEvent("segmentation-reset"))
      window.dispatchEvent(new CustomEvent(eventType))
      
      // Update URL parameter without reloading the page
      const url = new URL(window.location)
      const params = new URLSearchParams(url.search)
      params.set("seg", segType)
      url.search = params.toString()
      history.replaceState(null, "", url.toString())
    },
    handleStartLeadPopup() {
      this.isLeadPopup = true
    },
    handleLeadClose() {
      // wait for the animation to finish
      setTimeout(() => {
        this.isLeadPopup = false
      }, 300)
    },
  },
}
</script>

<style lang="postcss" scoped>
.benefit-title {
  font-family: var(--font-it-ex);
  font-size: var(--font-size-body);
  font-weight: 700;
  line-height: 24px;
  padding-bottom: 16px;

  @media (min-width: 1024px) {
    padding-bottom: 60px;
  }
}

.benefit-boxes {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-bottom: 26px;

  @media (min-width: 768px) {
    flex-direction: row;

    > * {
      flex: 1;
    }
  }

  @media (min-width: 1024px) {
    gap: calc(var(--grid-gutter) * 2);
  }
}
</style>
